<template>
  <b-card title="Inspecties">
    <b-nav tabs>
      <b-nav-item 
        v-for="(label,index) in tabRoutes" 
        :key="index"
        :active="tabRoute == label"
        :to="{name:label}"
      >
        {{ label }}
      </b-nav-item>
    </b-nav>
    <b-card-body>
      <router-view />
    </b-card-body>
  </b-card>
</template>
<script>
export default {
    name: 'InspectiesDashboard',
    data() {
        return {
            inspecties : []
        }
    },
    computed: {
        tabRoute: function () {
           return this.$route.matched[1].name
        },
        tabRoutes: function () {
            return ['Nieuwere inspecties']
        }
    },
    methods: {
        getInspecties() {
            // /administratie/inspecties
            return []
        },
    },
}
</script>